import { trackEvents } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ViewLoading from "shared/UI/Spinners/ViewLoading";
import { handleWisdomStoreClick } from "core/helpers/mobileStore";
import { useTranslation } from "react-i18next";
import { Platform } from "core/hooks/useMobilePlatform";
import { ReactComponent as AppleStoreSvg } from "shared/assets/AppleStore.svg";
import { ReactComponent as GooglePlaySvg } from "shared/assets/GooglePlay.svg";
import { ReactComponent as WisdomLogo } from "shared/assets/WisdomLogoDark.svg";

const AppStore = () => {
  return (
    <div className="h-screen bg-white bg-gradient-to-b from-brand-purple to-transparent flex items-center justify-center">
      <div className="space-y-20 flex flex-col items-center">
        <WisdomLogo className="text-white" />
        <div className="space-y-5">
          <AppleStoreSvg name="AppleStore" role="button" onClick={() => handleWisdomStoreClick(Platform.ios, EventNames.APP_DOWNLOAD)} width={214} />
          <GooglePlaySvg
            role="button"
            name="GooglePlay"
            onClick={() => handleWisdomStoreClick(Platform.android, EventNames.APP_DOWNLOAD)}
            width={214}
          />
        </div>
      </div>
    </div>
  );
};

export const DownloadApp = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const path = searchParams.get("path");
  const isMobileApp = !!window.flutter_inappwebview;

  const isIOSBrowser = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroidBrowser = /Android/i.test(navigator.userAgent);

  const destination = path ? `/${path}` : "/";

  const handleGetInStore = useCallback(() => {
    if (isIOSBrowser) {
      handleWisdomStoreClick(Platform.ios, EventNames.APP_DOWNLOAD);
    } else if (isAndroidBrowser) {
      handleWisdomStoreClick(Platform.android, EventNames.APP_DOWNLOAD);
    } else {
      navigate(destination);
    }
    setLoading(false);
  }, [destination, isAndroidBrowser, isIOSBrowser, navigate]);

  useEffect(() => {
    trackEvents(EventNames.APP_DOWNLOAD);

    if (isMobileApp) {
      navigate(destination);
    } else {
      handleGetInStore();
    }
    setLoading(false);
  }, [destination, handleGetInStore, isMobileApp, navigate]);

  if (loading) {
    return <ViewLoading label={t("auth.loading")} />;
  }

  return <AppStore />;
};
